import * as actions from './actionTypes'

export function setLanguage(selectedLanguage) {
  return {
    type: actions.SET_LANGUAGE,
    payload: selectedLanguage,
  }
}
